import React from 'react';

export default function InnovPulseSection() {
  return (
    <section id="innovpulse-section" className="relative bg-[#08080a] text-white py-20 lg:py-28 border-t border-white/5 overflow-hidden">
      {/* Ambient glow matching site theme */}
      <div className="absolute top-1/2 left-1/3 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-[#d42b92]/10 blur-[160px] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-4xl reveal-up">
          {/* Eyebrow */}
          <div className="text-[#ff8ec5] text-xs font-semibold tracking-[0.3em] uppercase mb-4">
            INNOVPULSE
          </div>

          {/* Heading */}
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white leading-[1.08]">
            Intelligence that <span className="text-[#d42b92]">compounds.</span>
          </h2>

          {/* Body Content */}
          <div className="mt-8 space-y-6 text-white/80 text-base sm:text-lg lg:text-xl leading-relaxed font-normal">
            <p>
              InnovPulse is InnovHer’s private intelligence layer, designed to transform fragmented information, ecosystem knowledge and venture data into actionable intelligence.
            </p>
            <p>
              It connects insights across ventures, markets, founders, investors, programs and emerging opportunities, creating an institutional memory that grows with every interaction. Powered by AI and InnovHer’s proprietary technology infrastructure, InnovPulse supports research, venture discovery, decision-making, portfolio intelligence and ecosystem connections.
            </p>
            <p>
              Rather than allowing valuable knowledge to disappear across conversations, documents and individual relationships, InnovPulse captures and connects it.
            </p>
            <p className="text-white font-medium">
              The result is a continuously evolving intelligence infrastructure, built to help InnovHer and its ventures see more, connect better and decide smarter.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
